module.exports = __webpack_public_path__ + "img/platinum-visa.c78570b6.png";